import React from 'react';

const TogglableComponent = (Comp) => ({ visible=true, ...props }) => visible !== false ? <Comp {...props} /> : null

export default TogglableComponent